import { GetterTree } from 'vuex';

import {
  SubsStateI,
} from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<SubsStateI, RootStateI> = {
};
